import React from 'react';
import { TableCell, Box, Chip, Tooltip, Typography } from '@mui/material';
import ReactCountryFlag from 'react-country-flag';
import { Worker } from '../../../models/worker';

/** Map a language code to a representative ISO country code for flag display. */
const getCountryCode = (languageCode: string | undefined | null): string => {
    if (!languageCode) return '';
    const lc = languageCode.toLowerCase();
    const map: Record<string, string> = {
        en: 'GB', de: 'DE', nl: 'NL', pl: 'PL', ru: 'RU', hu: 'HU',
        fr: 'FR', ro: 'RO', es: 'ES', it: 'IT', cs: 'CZ', bg: 'BG',
        hr: 'HR', tr: 'TR', pt: 'PT', lt: 'LT', lv: 'LV', et: 'EE',
        sk: 'SK', sl: 'SI', da: 'DK', fi: 'FI', sv: 'SE', no: 'NO',
        uk: 'UA', is: 'IS', ga: 'IE', he: 'IL', id: 'ID', ms: 'MY',
        mt: 'MT', gl: 'ES', eu: 'ES', ca: 'ES', sr: 'RS', mk: 'MK',
        kk: 'KZ', az: 'AZ', fa: 'IR', am: 'ET', ar: 'SA', vi: 'VN',
        zh: 'CN', 'zh-cn': 'CN', 'zh-tw': 'TW', ja: 'JP', ko: 'KR',
        hi: 'IN', bn: 'BD', ur: 'PK', th: 'TH', el: 'GR', ta: 'IN',
        te: 'IN', mr: 'IN', pa: 'IN',
        sq: 'AL', hy: 'AM', ka: 'GE', sw: 'KE',
    };
    return map[lc] || map[lc.split('-')[0]] || lc.toUpperCase();
};

const WorkerLanguageCell: React.FC<{ worker: Worker }> = ({ worker }) => (
    <TableCell>
        {worker.languages && worker.languages.length > 0 ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                {worker.languages.slice(0, 3).map((lc) => {
                    const code = (lc || '').toLowerCase();
                    const cc = getCountryCode(code);
                    return (
                        <Chip
                            key={lc}
                            size="small"
                            variant="outlined"
                            icon={<ReactCountryFlag countryCode={cc} svg cdnUrl="/flags/4x3/" cdnSuffix="svg" style={{ width: '1em', height: '1em' }} />}
                            label={code.toUpperCase()}
                            sx={{ bgcolor: 'transparent', height: 22, '& .MuiChip-label': { px: 0.75 } }}
                        />
                    );
                })}
                {worker.languages.length > 3 && (
                    <Tooltip title={worker.languages.slice(3).map((c) => c.toUpperCase()).join(', ')}>
                        <Chip size="small" variant="outlined" label={`+${worker.languages.length - 3}`} sx={{ bgcolor: 'transparent', height: 22 }} />
                    </Tooltip>
                )}
            </Box>
        ) : (
            <Typography variant="body2" color="text.secondary">N/A</Typography>
        )}
    </TableCell>
);

export default WorkerLanguageCell;
